import { defineMessages } from 'react-intl';

import type { CustomField } from '@atlaskit/editor-common/extensions/field-definitions';

import type { FieldTransformer } from './fieldTypes.ts';

const i18n = defineMessages({
	searchCalendarPlaceholder: {
		id: 'fabric-extension-lib.field-mappings.calendar.field.search.placeholder',
		description: 'The placeholder for search calendar text box.',
		defaultMessage: 'Begin typing to search your calendars',
	},
});

// Used by the non-legacy Team Calendar update path; move this into `transformAfter`
// when the legacy macro-browser update path no longer needs to preserve old behavior.
export const normalizeNonLegacyCalendarMacroParams = (
	params: Record<string, unknown>,
): Record<string, unknown> => {
	const normalizedParams = { ...params };

	if (Array.isArray(normalizedParams.id)) {
		normalizedParams.id = normalizedParams.id.join(',');
	}

	['width', 'height'].forEach((key) => {
		const value = normalizedParams[key];
		if (value === undefined || value === null || value === '') {
			delete normalizedParams[key];
			return;
		}

		normalizedParams[key] = String(value);
	});

	if (typeof normalizedParams.hideWeekends === 'boolean') {
		normalizedParams.hideWeekends = String(normalizedParams.hideWeekends);
	}

	return normalizedParams;
};

export const calendar: FieldTransformer<any> = {
	transformFields: async ({ fields, intl }) => {
		return fields.map((field) => {
			if (field.name !== 'id') {
				return field;
			}

			return {
				...field,
				type: 'custom',
				isMultiple: true,
				options: {
					resolver: {
						type: 'calendar',
					},
				},
				placeholder: intl.formatMessage(i18n.searchCalendarPlaceholder),
			} as CustomField;
		});
	},
	// Custom field receives an array
	transformBefore(params) {
		if (params.id && typeof params.id === 'string') {
			params.id = params.id.split(',');
		}
		return params;
	},
	// Custom field returns an array, so converting it back to string to store
	transformAfter(params) {
		if (Array.isArray(params.id)) {
			params.id = params.id.join(',');
		}
		return params;
	},
};
